import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class SlotRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param serviceId
   * @param date
   */
  list(token: string, serviceId: number, date: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param date
   */
  listAQP(token: string, serviceId: number, date: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_LIST_AQP;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param date
   * @param type
   */
  day(token: string, serviceId: number, date: string, type: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_DAY;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());
    form.set(RequestField.TYPE, type.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   */
  visibility() {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_VISIBILITY;

    return this.network.http().get(url);
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param date
   * @param time
   */
  create(
    token: string,
    serviceId: number,
    date: string,
    time: string,
    flag: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());
    form.set(RequestField.TIME, time.toString());
    form.set(RequestField.FLAG, flag.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param slotId
   * @param date
   * @param time
   * @param flag
   */
  update(
    token: string,
    serviceId: number,
    slotId: number,
    date: string,
    time: string,
    flag: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.SLOT_ID, slotId.toString());
    form.set(RequestField.DATE, date.toString());
    form.set(RequestField.TIME, time.toString());
    form.set(RequestField.FLAG, flag.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param date
   * @param time
   */
  delete(token: string, serviceId: number, date: string, time: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_DELETE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());
    form.set(RequestField.TIME, time.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  deleteAll(token: string, serviceId: number, date: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_DELETE_ALL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATE, date.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param slotId
   */
  deletePrenotation(token: string, serviceId: number, slotId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_DELETE_PRENOTATION;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.SLOT_ID, slotId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param slotId
   */
  deletePrenotationAQP(
    token: string,
    serviceId: number,
    slotId: number,
    map: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_DELETE_PRENOTATION_AQP;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.SLOT_ID, slotId.toString());
    form.set(RequestField.PARAMS, map.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param data
   */
  createPrenotation(token: string, serviceId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_CREATE_PRENOTATION;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param data
   */
  createPrenotationAQP(
    token: string,
    serviceId: number,
    data: string,
    map: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_CREATE_PRENOTATION_AQP;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATA, data.toString());
    form.set(RequestField.PARAMS, map.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param data
   */
  updatePrenotation(token: string, serviceId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_UPDATE_PRENOTATION;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param data
   */
  updatePrenotationAQP(
    token: string,
    serviceId: number,
    data: string,
    map: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_UPDATE_PRENOTATION_AQP;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DATA, data.toString());
    form.set(RequestField.PARAMS, map.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceCode
   * @param dayId
   * @param operation
   * @param days
   * @param siteList
   * @param dateBegin
   * @param dateEnd
   * @param holidays
   */
  massImport(
    token: string,
    serviceCode: string,
    serviceId: number,
    dayId: number,
    operation: string,
    days: string,
    siteList: string,
    dateBegin: string,
    dateEnd: string,
    holidays: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOT_MASS_IMPORT;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    if (serviceCode)
      form.set(RequestField.SERVICE_CODE, serviceCode.toString());
    else form.set(RequestField.SERVICE_ID, serviceId.toString());

    form.set(RequestField.DAY_ID, dayId.toString());
    form.set(RequestField.OPERATION, operation.toString());
    form.set(RequestField.WEEK_DAYS, days.toString());
    form.set(RequestField.SITE_LIST, siteList.toString());
    form.set(RequestField.DATE_FROM, dateBegin.toString());
    form.set(RequestField.DATE_TO, dateEnd.toString());
    form.set(RequestField.HOLIDAYS, holidays.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
